import {
    borrarDefaultDropDownOptions,
    defaultHeaderDropDown,
    freezeGenericMessage,
    setShowCheckStatus,
} from "../../../common/dataTables/utils";

const dataTableDescargaElement = document.getElementById("dataTableDescarga");

const columns = [
    {
        id: "pedimento",
        name: "Pedimento",
        dropdown: true,
        sortable: true,
        width: 200,
        format: (value) => {
            if (value == null) return "";

            let valueContent = value;
            let valueToolTip = value;

            if (value.includes('(DESP)')) {
                valueContent = (value.split(" ") || "");
                valueContent = valueContent.filter(function (onlyNumberPedimento) {
                    return onlyNumberPedimento !== '(DESP)';
                });

                valueContent = valueContent.join(' ')
                valueToolTip = valueContent + "\nDesperdicio generado por un descargo.";
                return `<span title="${valueToolTip}">${valueContent}<b>${' (DESP)'}</b></span>`;
            }

            return `<span title="${valueToolTip}">${valueContent}</span>`;
        }
    },
    {
        id: "clave_documento",
        name: "Clave",
        sortable: true,
        dropdown: true,
        width: 72,
        align: "center",
    },
    {
        id: "fecha_pago",
        name: "Fecha",
        sortable: true,
        dropdown: true,
        width: 108,
    },
    {
        id: "material",
        name: "Material",
        dropdown: true,
        sortable: true,
        width: 160,
    },
    {
        id: "cantidad",
        name: "Cantidad",
        sortable: true,
        dropdown: true,
        width: 100,
        align: "right",
    },
    {
        id: "cantidad_utilizar",
        name: "Cantidad a utilizar",
        editable: true,
        resizable: true,
        sortable: true,
        focusable: true,
        dropdown: true,
        width: 175,
    },
    {
        id: "item-selected",
        name: "",
        format: (value) => {
            if (value) {
                return `<span data-item-selected='${value}'></span>`;
            }
            return "";
        },
    },
];

export const dataTableDescarga = new DataTable(dataTableDescargaElement, {
    columns: columns.map((item) => ({ ...dataTableColumnCommonConfiguration, ...item })),
    headerDropdown: defaultHeaderDropDown,
    inlineFilters: true,
    serialNoColumn: false,
    checkboxColumn: true,
    noDataMessage: "Sin pedimentos de importación disponibles",
    freezeMessage: freezeGenericMessage,
    getEditor(colIndex, rowIndex, valueCell, parent, column, row, data) {
        // colIndex, rowIndex of the cell being edited
        // value: value of cell before edit
        // parent: edit container (use this to append your own custom control)
        // column: the column object of editing cell
        // row: the row of editing cell
        // data: array of all rows

        const $input = document.createElement("input");
        $input.type = "text";
        $input.classList.add("form-control");
        parent.appendChild($input);

        return {
            // called when cell is being edited
            initValue(value) {
                $input.focus();
                $input.value = value || "";
            },
            // called when cell value is set
            // eslint-disable-next-line consistent-return
            setValue(value) {
                if (!value) {
                    return Promise.reject(new Error("El valor esta vacio"));
                }

                if (!new RegExp(/^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/).test(value)) {
                    crearToast("¡Error!", "Ingresa un valor valido por favor.", "warning", 5000);
                    return Promise.reject(new Error("El valor no es valido"));
                }

                const newValue = parseFloat(value);
                const { cantidad } = data;
                if (newValue > cantidad) {
                    crearToast(
                        "¡Error!",
                        "El valor ingresado no puede ser mayor a la cantidad disponible.",
                        "warning",
                        5000,
                    );
                    return Promise.reject(new Error("El valor ingresado no puede ser mayor a la cantidad disponible."));
                }
                if (newValue <= 0) {
                    crearToast("¡Error!", "El valor ingresado debe ser mayor a cero.", "warning", 5000);

                    return Promise.reject(new Error("El valor ingresado debe ser mayor a cero."));
                }

                $input.value = newValue;
                data.cantidad_utilizar = newValue;
            },
            // value to show in cell
            getValue() {
                return $input.value;
            },
        };
    },
});

borrarDefaultDropDownOptions(dataTableDescarga);
setShowCheckStatus(dataTableDescarga, "pedimento", "seleccionado");
